import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-

import { StandaloneSearchBoxes } from '../common/StandaloneSearchBoxes.js';
import '../common/Svg.js';
import '../common/locationUtils.js';
import '../common/LightBoxWrapper.js';
import MapCalloutPoint from '../../../images/donor-map/map-callout-point.svg';
import UrgentProjectsSection from './UrgentProjectsSection.tsx';
import LocalProjectsSection from './LocalProjectsSection.js';
import MatchingProjectsSection from './MatchingProjectsSection.js';
import EquityFocusProjectsSection from './EquityFocusProjectsSection.js';
import RecurringDonationSection from './RecurringDonationSection.js';
import { CalendarBannerSection } from './CalendarBannerSection.js';
import { TrackSectionView } from '../common/TrackSectionView.js';


let NewDonorHome = function (props) {
    const searchURL = props.baseSearchURL;
    const detectedLocation = props.detectedLocation;
    const FirstSection = detectedLocation ? LocalProjectsSection : UrgentProjectsSection;

    return (
        <div className="homepage-newbs">
            <TrackSectionView sectionName="New donor intro">
                <section className="photo-fill right-text three-quarters new-donor-intro">
                    <div className="container">
                        <div className="text-wrapper">

                            <h1>Choose students.<br/><span className="highlight">Shape the future.</span></h1>
                            <p className="subheader">Teachers need books, pencils, technology, and more to help students excel. Support a classroom in your community, or beyond, so every kid has the tools <span className="no-wrap">to succeed.</span></p>
                            <a href={baseURL + 'donors/search.html'} className="button-primary">See classroom projects</a>
                            <p className="supporting-text">Our <a href={baseURL + 'about/finance.html'}>efficiency and transparency</a> have earned us the highest rating on Better Business Bureau and Charity Navigator.</p>

                        </div>
                    </div>
                </section>
            </TrackSectionView>

            <TrackSectionView sectionName="Search projects">
                <div className="search-projects">
                    <StandaloneSearchBoxes searchURL={searchURL} baseSearchURL={searchURL}
                        detectedLocation={props.detectedLocation}
                        filterCategories={props.filterCategories} extraFilters={props.extraFilters} />
                </div>
            </TrackSectionView>
            <TrackSectionView sectionName="Calendar banner section">
                <CalendarBannerSection />
            </TrackSectionView>

            <div id="first-section-wrapper">{/* Do not delete this div or change this ID without checking for corresponding JS usage */}
                <FirstSection {...props} />
            </div>
            <TrackSectionView sectionName="Classroom essentials">
                <section className="classroom-essentials-callout">
                    <div className="container">
                        <div className="essentials-content">
                            <div className="supply-side">
                                <div className="animated-supply">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div className="badge"></div>
                            </div>
                            <div className="text-content">
                                <h1>Give the <span className="essentials-color">most requested</span> basic supplies</h1>
                                <a className="button-primary essentials" href="/donors/search.html?essentialsListsOnly=true">See teacher requests</a>
                            </div>
                        </div>
                    </div>
                </section>
            </TrackSectionView>


            <TrackSectionView sectionName="About us">
                <section className="tapestry about-us">
                    <div className="container">
                        <h2>About us</h2>
                        {/* COVID timely messaging */}
                        <p className="subheader">Founded in 2000 by a high school teacher in the Bronx, DonorsChoose empowers public school teachers from across the country to request much-needed materials for their students. Right now there are thousands of teacher requests that you can help bring to life with a gift of any amount.</p>
                        {/* <p className="subheader">Founded in 2000 by a high school teacher in the Bronx, DonorsChoose empowers public school teachers from across the country to request much-needed materials and experiences for their students. Right now there are thousands of classroom requests that you can help bring to life with a gift of <span className="no-wrap">any amount.</span></p> */}
                        <a href={baseURL + 'about'} className="button-secondary button-overlay">Read the story</a>
                    </div>
                </section>
            </TrackSectionView>

            <RecurringDonationSection {...props} />

            <TrackSectionView sectionName="Map">
                <section className="map-feature-callout">
                    <div className="container">
                        <div className="fluid-container">
                            <div className="col col6">
                                <div className="point-group">
                                    <svg className="pinpoint" width="88" height="161" viewBox="0 0 88 161" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <ellipse cx="44" cy="144" rx="43" ry="17" fill="#E3C0AD" fill-opacity="0.33"/>
                                        <path
                                            d="M44 0C19.7016 0 0 19.925 0 44.4989C0 91.1073 44 138 44 138C44 138 88 92.0595 88 44.4989C88 19.925 68.3049 0 44 0ZM44 66.6259C32.7074 66.6259 23.553 57.3677 23.553 45.9471C23.553 34.5265 32.7074 25.2683 44 25.2683C55.2926 25.2683 64.447 34.5265 64.447 45.9471C64.447 57.3677 55.2926 66.6259 44 66.6259Z"
                                            fill="#FF6969"/>
                                    </svg>
                                </div>
                                <div className="underlying-project-points">
                                    <MapCalloutPoint />
                                    <MapCalloutPoint />
                                    <MapCalloutPoint />
                                    <MapCalloutPoint />
                                    <MapCalloutPoint />
                                    <MapCalloutPoint />
                                </div>
                            </div>
                            <div className="col col6 map-callout-copy">
                                <h2>Give back to your community</h2>
                                <p>Find opportunities to impact local needs by exploring a map of classroom projects near you.</p>
                                <a className="button-primary" href={`${baseURL}donors/map.html`}>See local area</a>
                            </div>
                        </div>
                    </div>
                </section>
            </TrackSectionView>

            <TrackSectionView sectionName="Transparency and Efficiency">
                <section className="yellow infotainment integrity">
                    <div className="container left-illustration">
                        <h2>Transparency &amp; Efficiency</h2>
                        <p className="subheader">We know that you care about how effectively your donation is being used. That{"'"}s why we show you how every dollar was spent, how you made a difference, and how grateful the students and <span className="no-wrap">teachers are!</span></p>
                        <h4>We{"'"}ve received the highest possible ratings from:</h4>
                        <ul className="charity-rating-list">
                            <li>
                                <a href="https://give.org/charity-reviews/national/Education-and-Literacy/DonorsChoose.org-in-New-York-ny-15136"
                                   className="label-link" target="_blank"
                                   title="See DonorsChoose's profile on Better Business Bureau">Better Business
                                    Bureau</a>
                            </li>
                            <li>
                                <a href="https://www.charitywatch.org/ratings-and-metrics/donorschooseorg/706"
                                   className="label-link" target="_blank" rel="noopener noreferrer"
                                   title="See DonorsChoose's profile on Charity Watch">Charity Watch</a>
                            </li>
                            <li>
                                <a href="https://www.charitynavigator.org/ein/134129457"
                                   className="label-link" target="_blank" rel="noopener noreferrer"
                                   title="See DonorsChoose's profile on Charity Navigator">Charity Navigator</a>
                            </li>
                            <li>
                                <a href="https://www.guidestar.org/profile/13-4129457" className="label-link"
                                   target="_blank" rel="noopener noreferrer"
                                   title="See DonorsChoose's profile on GuideStar">Guidestar</a>
                            </li>
                        </ul>
                        <a href={baseURL + 'about/finance.html'} className="button-secondary">See finances</a>
                    </div>
                </section>
            </TrackSectionView>

            <MatchingProjectsSection {...props} />

            <TrackSectionView sectionName="New teacher large banner">
                <section className="tapestry full-color for-teachers">
                    <div className="container">
                        <h2>The most trusted classroom funding site for teachers</h2>
                        <p className="subheader">As a teacher-founded nonprofit, we&rsquo;re trusted by teachers, donors, administrators, and partner organizations across the country.</p>
                        <a className="button-secondary button-overlay" href={baseURL + 'teachers'}>
                                Learn how to get funded
                        </a>
                    </div>
                </section>
            </TrackSectionView>

            <EquityFocusProjectsSection {...props} />

            <TrackSectionView sectionName="Browse all projects">
                <section className="browse-all-projects">
                    <div className="container">
                        {/* COVID timely messaging */}
                        <h2 className="subheader">Looking to help out? There are thousands of exciting teacher requests that would benefit from a donation of any size!</h2>
                        <a href={searchURL} className="button-secondary">Find a request to support</a>

                        {/* <h2 className="subheader">Looking to help out? There are thousands of exciting classroom projects that would benefit from a donation of any size!</h2> */}
                        {/* <a href={searchURL} className="button-secondary">Find a classroom to support</a> */}
                    </div>
                </section>
            </TrackSectionView>

        </div>
    );
};

NewDonorHome.propTypes = {
    baseSearchURL: PropTypes.string.isRequired,
    loadProjects: PropTypes.func.isRequired,
    getProjects: PropTypes.func.isRequired,
    detectedLocation: PropTypes.object,
    filterCategories: PropTypes.array,
    extraFilters: PropTypes.array,
};
NewDonorHome = React.memo(NewDonorHome);
export default NewDonorHome;
